module.exports = __webpack_public_path__ + "img/house_14.802d4018.jpg";